
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/quotes/[page]",
      function () {
        return require("private-next-pages/[region]/quotes/[page]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/quotes/[page]"])
      });
    }
  